import { apiClient } from './client';
import {
  CashTransaction,
  CashInValidateResponse,
  CashOutValidateResponse,
  CashConfirmRequest,
  CashConfirmResponse,
  FeeEstimateResponse,
  TransactionListResponse,
  ReversalResponse,
  TransactionType,
  TransactionStatus,
} from '../types/cash-transaction.types';

// ─── Legacy DTO (mantenido para compatibilidad con useCashTransactions hook) ──
export interface CreateCashTransactionDto {
  type: TransactionType;
  amount: number;
  customerIdentifier: string;
  reference?: string;
  notes?: string;
}

export const cashTransactionsApi = {
  // ─── CASH-IN ──────────────────────────────────────────────────────────────

  // Paso 3: El agente ingresa el código OTP del cliente → previsualiza
  validateCashInCode: async (code: string): Promise<CashInValidateResponse> => {
    const { data } = await apiClient.post('/agent/cash-in/validate-code', { code });
    return data;
  },

  // Paso 4: El agente confirma con su PIN/contraseña → mueve fondos
  confirmCashIn: async (payload: CashConfirmRequest): Promise<CashConfirmResponse> => {
    const { data } = await apiClient.post('/agent/cash-in/confirm', payload);
    return data;
  },

  // ─── CASH-OUT ─────────────────────────────────────────────────────────────

  // Paso 3: El agente ingresa el código OTP del cliente → previsualiza
  validateCashOutCode: async (code: string): Promise<CashOutValidateResponse> => {
    const { data } = await apiClient.post('/agent/cash-out/validate-code', { code });
    return data;
  },

  // Paso 4: El agente confirma con su PIN/contraseña → mueve fondos
  confirmCashOut: async (payload: CashConfirmRequest): Promise<CashConfirmResponse> => {
    const { data } = await apiClient.post('/agent/cash-out/confirm', payload);
    return data;
  },

  // ─── FEE ESTIMATION ──────────────────────────────────────────────────────

  // Estimar fee de cash-in dado un monto (sin validar código)
  estimateCashInFee: async (amount: number): Promise<FeeEstimateResponse> => {
    const { data } = await apiClient.get('/agent/cash-in/estimate-fee', { params: { amount } });
    return data;
  },

  // Estimar fee de cash-out dado un monto (sin validar código)
  estimateCashOutFee: async (amount: number): Promise<FeeEstimateResponse> => {
    const { data } = await apiClient.get('/agent/cash-out/estimate-fee', { params: { amount } });
    return data;
  },

  // ─── TRANSACTIONS LIST ────────────────────────────────────────────────────

  // Historial de transacciones del agente con filtros, búsqueda y paginación
  getAll: async (filters?: {
    page?: number;
    limit?: number;
    type?: TransactionType;
    status?: TransactionStatus | string;
    startDate?: string;
    endDate?: string;
    search?: string;
  }): Promise<TransactionListResponse> => {
    const { data } = await apiClient.get('/agents/me/transactions', { params: filters });
    return data;
  },

  // Detalle de una transacción
  getById: async (id: string): Promise<CashTransaction> => {
    const { data } = await apiClient.get(`/agents/me/transactions/${id}`);
    return data;
  },

  // Solicitar reversión de una transacción
  requestReversal: async (id: string, reason: string): Promise<ReversalResponse> => {
    const { data } = await apiClient.post(`/agents/me/transactions/${id}/reverse`, { reason });
    return data;
  },
};

